var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 5C15 5 15.5 4.5 15.5 4C15.5 3.5 15 3 14.5 3H5.5C4.4 3 3.5 3.9 3.5 5V14C3.5 14.5 4 15 4.5 15C5 15 5.5 14.5 5.5 14V5H14.5ZM9.5 21H18.5C19.6 21 20.5 20.1 20.5 19V9C20.5 7.9 19.6 7 18.5 7H9.5C8.4 7 7.5 7.9 7.5 9V19C7.5 20.1 8.4 21 9.5 21ZM9.5 19V9H18.5V19H9.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy.f344b1333b33deaf7e05caec700b65ec.svg";